// extracted by mini-css-extract-plugin
export default {"closeWrap":"styles_closeWrap__m7bDf","close":"styles_close__hjdY1"};